<script lang="ts">
  import { fontSize } from '../stores';
  // numeric font size handling (px)
  const MIN_FONT = 12;
  const MAX_FONT = 64;
  const STEP = 2;
  function increase() {
    fontSize.update(v => Math.min(v + STEP, MAX_FONT));
  }
  function decrease() {
    fontSize.update(v => Math.max(v - STEP, MIN_FONT));
  }
</script>

<div class="inline-flex items-center shrink-0" style="gap: 8px;">
  <button 
    on:click={decrease} 
    class="flex items-center justify-center bg-white text-blue-800 rounded-md font-semibold hover:bg-gray-100 active:bg-gray-200" 
    style="width: 36px; height: 30px; font-size: 13px; line-height: 1; padding: 0;"
  >
    A-
  </button>
  <button 
    on:click={() => fontSize.set(28)} 
    class="flex items-center justify-center bg-white text-blue-800 rounded-md hover:bg-gray-100 active:bg-gray-200" 
    style="width: 36px; height: 30px; font-size: 13px; line-height: 1; padding: 0; font-family: ui-monospace, monospace; font-variant-numeric: tabular-nums;" 
    title="點擊恢復預設字型大小 28px"
  >
    {$fontSize}
  </button>
  <button 
    on:click={increase} 
    class="flex items-center justify-center bg-white text-blue-800 rounded-md font-semibold hover:bg-gray-100 active:bg-gray-200" 
    style="width: 36px; height: 30px; font-size: 13px; line-height: 1; padding: 0;"
  >
    A+
  </button>
</div>
